
import { Component, Vue, Prop } from "vue-property-decorator"

/**
 * Delete button
 */
@Component({})
export default class DeleteButton extends Vue {
	@Prop({ type: Boolean, default: false })
	noBackground!: boolean

	@Prop({ type: Boolean, default: false })
	readonly!: boolean

	handleClickEvent (event: any) {
		if (this.readonly === false) {
			this.$emit("click", event)
		}
	}
}
